import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { getSessionObject } from "./utils/sessionUtils.js";
import { ROLES } from "./utils/enums";
import YourProfile from "./views/Onboarding/YourProfile";
import ConfirmationCode from "./views/Authentication/ConfirmationCode";
import RiskQuiz from "./views/Onboarding/RiskQuiz";
import StrategySelection from "./views/Onboarding/StrategySelection";
import AccountType from "./views/Onboarding/AccountType";
import Register from "./views/Authentication/Register";
import Login from "./views/Authentication/Login";
import EditProfile from "./views/Platform/widgets/profile/EditProfile.jsx";
import TradierAccess from "./views/Authentication/TradierAccess";
import BrokerConnection from "./views/Platform/modules/clients/BrokerConnection.jsx";
import Notifications from "./views/Platform/modules/clients/Notifications.jsx";
import Transactions from "./views/Platform/modules/clients/Transactions.jsx";
import DashboardController from "./views/Platform/DashboardController.jsx";
import TradingSetup from "./views/Platform/modules/clients/TradingSetup.jsx";
import Strategies from "./views/Platform/modules/fundManagers/Strategies.jsx";
import UserManagement from "./views/Platform/modules/admins/UsersManagement.jsx";
import AdminTwoFactorManagement from "./views/Platform/modules/admins/AdminTwoFactorManagement.jsx";
import StrategyDetail from "./views/Platform/modules/fundManagers/StrategyDetail.jsx";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import Unauthorized from "./views/Authentication/Unauthorized.jsx";
import ReportsController from "./views/Platform/ReportsController.jsx";
import MyClientsController from "./views/Platform/MyClientsController.jsx";
import Portfolio from "./views/Platform/modules/clients/Portfolio.jsx";
import { TimeFilterProvider } from "./contexts/TimeFilterContext.js";
import { ApplicationProvider } from "./contexts/ApplicationContext.js";
import RiskAssessment from "./views/Platform/modules/clients/RiskAssesment.jsx";
import Funding from "./views/Platform/modules/clients/Funding.jsx";
import Agreements from "./views/Onboarding/Agreements.jsx";
import FeesView from "./views/Platform/modules/admins/FeesView.jsx";
import Documents from "./views/Onboarding/Documents.jsx";
import Status from "./views/Onboarding/Status.jsx";
import ClientDashboard from "./views/Platform/modules/clients/ClientDashboard.jsx";
import "./App.css";
import "./styles/reset-filters.css";
import RecoverPassword from "./views/Authentication/RecoverPassword.jsx";

const { ADMIN, MANAGER, CUSTOMER, ADVISOR, SUPPORT } = ROLES;
// TODO: Improve routing per role on separated files
export const DefRoutes = [
  {
    path: "/dashboard",
    value: "dashboard",
    icon: "dashboard",
    title: "Dashboard",
    isActive: false,
    Component: <DashboardController />,
    allowedRoles: [ADMIN, MANAGER, CUSTOMER, ADVISOR, SUPPORT],
  },
  {
    path: "/trading-setup",
    value: "trading-setup",
    icon: "settings",
    title: "Trading setup",
    isActive: false,
    Component: <TradingSetup />,
    allowedRoles: [
      /*CUSTOMER*/
    ],
  },
  {
    path: "/my-clients",
    value: "my-clients",
    icon: "clients",
    title: "My clients",
    isActive: false,
    Component: <MyClientsController />,
    allowedRoles: [
      /*ADVISOR, ADMIN*/
    ],
  },
  {
    path: "/admin/transactions",
    value: "transactions",
    icon: "transactions",
    title: "Transactions",
    isActive: false,
    Component: <Transactions />,
    allowedRoles: [],
  },
  {
    path: "/reports",
    value: "reports",
    icon: "stats",
    title: "Reports",
    isActive: false,
    Component: <ReportsController />,
    allowedRoles: [CUSTOMER],
  },
  {
    path: "/portfolio",
    value: "portfolio",
    icon: "wallet",
    title: "Portfolio",
    isActive: false,
    Component: (
      <TimeFilterProvider>
        <Portfolio />
      </TimeFilterProvider>
    ),
    allowedRoles: [
      /*CUSTOMER*/
    ],
  },  {
    path: "/admin/user-management",
    value: "user-management",
    icon: "user-add",
    title: "User management",
    isActive: false,
    Component: <UserManagement />,
    allowedRoles: [ADMIN, SUPPORT],
  },
  {
    path: "/admin/2fa-management",
    value: "2fa-management",
    icon: "settings",
    title: "2FA Management",
    isActive: false,
    Component: <AdminTwoFactorManagement />,
    allowedRoles: [ADMIN, SUPPORT],
  },
  {
    path: "/strategies",
    icon: "strategies",
    vaue: "strategies",
    title: "Strategies",
    isActive: false,
    Component: <Strategies />, // REVIEW WHICH COMPONENT IS WHICH?
    allowedRoles: [ADMIN, SUPPORT, CUSTOMER /*, MANAGER*/],
  },
  // {
  //   path: "/chat",
  //   value: "chat",
  //   icon: "chat",
  //   title: "Chat",
  //   isActive: false,
  //   Component: <Chat />,
  //   allowedRoles: [ADMIN, CUSTOMER, ADVISOR, MANAGER],
  // },
  {
    path: "/risk-assessment",
    value: "risk-assessment",
    icon: "settings",
    title: "Risk assessment",
    isActive: false,
    Component: <RiskAssessment />,
    allowedRoles: [CUSTOMER],
  },
  {
    path: "/funding",
    value: "funding",
    icon: "wallet",
    title: "Funding",
    isActive: false,
    Component: <Funding />,
    allowedRoles: [CUSTOMER],
  },
  // {
  //   path: "/broker-connection",
  //   value: "broker-connection",
  //   icon: "wallet",
  //   title: "Broker connection",
  //   isActive: false,
  //   Component: <BrokerConnection />,
  //   allowedRoles: [],
  // },
  {
    path: "/edit-profile",
    value: "settings",
    icon: "settings",
    title: "Settings",
    isActive: false,
    Component: <EditProfile />,
    allowedRoles: [CUSTOMER,ADMIN, SUPPORT, ADVISOR, MANAGER],
  },
  {
    path: "/strategies/strategy/:id",
    Component: (
      <ErrorBoundary>
        <StrategyDetail />
      </ErrorBoundary>
    ),
    allowedRoles: [ADMIN, SUPPORT, MANAGER, CUSTOMER],
  },
  {
    path: "/edit-profile",
    Component: <EditProfile />,
    allowedRoles: [ADMIN, SUPPORT, CUSTOMER, ADVISOR, MANAGER],
  },
  {
    path: "/notifications",
    Component: <Notifications />,
    allowedRoles: [ADMIN, SUPPORT, CUSTOMER, ADVISOR, MANAGER],
  },
  {
    path: "/fees",
    value: "Fees",
    icon: "fees",
    title: "Fees",
    isActive: true,
    Component: <FeesView/>,
    allowedRoles: [ADMIN, SUPPORT, CUSTOMER, ADVISOR],
  },
];

const App = () => {
  const [userRole, setUserRole] = useState(getSessionObject().role);

  const checkRoles = (allowedRoles, userRoles) => {
    return allowedRoles.includes(userRoles[0]);
  };
  const PrivateRoute = ({ element, allowedRoles, userRoles }) => {
    return checkRoles(allowedRoles, userRoles) ? (
      element
    ) : (
      <Navigate to="/unauthorized" />
    );
  };

  return (
    <Router>
      <Routes>
        {/* COMMON ROUTES */}
        <Route
          path="/"
          element={
            // isUserLoggedIn ? (
            //   <Navigate to="/dashboard" replace={true} />
            // ) : (
            <Navigate to="/login" replace={true} />
            // )
          }
        />
        <Route exact path="/register" element={<Register />} />
        <Route
          exact
          path="/login"
          element={<Login setUserRole={setUserRole} />}
        />
        <Route exact path="/unauthorized" element={<Unauthorized />} />
        <Route exact path="/access/tradier" element={<TradierAccess />} />
        <Route exact path="/broker-connection" element={<BrokerConnection />} />
        <Route
          exact
          path="/onboarding/confirmation-code"
          element={<ConfirmationCode />}
        />
        <Route
          exact
          path="/onboarding/your-profile"
          element={
            <ApplicationProvider>
              <YourProfile />
            </ApplicationProvider>
          }
        />
        <Route
          exact
          path="/onboarding/account-type"
          element={<AccountType />}
        />
        <Route exact path="/onboarding/agreements" element={<Agreements />} />
        <Route
          exact
          path="/onboarding/agreements/:applicationId"
          element={<Agreements />}
        />
        <Route
          exact
          path="/onboarding/status/:applicationId"
          element={<Status />}
        />
        <Route exact path="/onboarding/documents" element={<Documents />} />
        <Route exact path="/onboarding/status" element={<Status />} />
        <Route exact path="/onboarding/risk-quiz" element={<RiskQuiz />} />
        <Route
          exact
          path="/onboarding/strategy"
          element={<StrategySelection />}
        />
        <Route exact path="/recover-password" element={<RecoverPassword />} />
        {/* RESTRICTED ROUTES */}
        {DefRoutes.map(({ path, Component, allowedRoles }) => (
          <Route
            key={path}
            path={path}
            element={
              <PrivateRoute
                element={Component}
                allowedRoles={allowedRoles}
                userRoles={[userRole]}
              />
            }
          />
        ))}
        <Route
          key={"dashboard-customer"}
          path="/dashboard/customer/:id"
          element={
            <PrivateRoute
              element={<ClientDashboard />}
              allowedRoles={[ADMIN, SUPPORT, ADVISOR]}
              userRoles={[userRole]}
            />
          }        />
      </Routes>
    </Router>
  );
};

export default App;
